<template>
  <b-modal id="ruleEditModal" :title="$t('feeds.edit_rule')" centered size="xl">
    <template #modal-header>
      <div class="d-flex align-items-center">
        <h6 class="mb-0">{{$t('feeds.edit_rule')}}</h6>
        <edit-icon size="1.6x" class="mx-3"></edit-icon>
      </div>
      <button class="btn btn-tiny btn-gray btn-close" @click="hideModal"><x-icon></x-icon></button>
    </template>
    <div>
      <source-variable
        @onMappingRuleSelect="updateMappingRule"
        :mappingRule="rule.mappingRule"
        :mappingRules="mappingRules">
      </source-variable>
      <conditions
        @onConditionsChange="updateConditions"
        @onConditionsValidate="updateConditionsValidity"
        :savedConditions="rule.conditions"
        :availableSourceVariables="availableSourceVariables">
      </conditions>
      <format
        @onRuleTypeSelect="updateRuleType"
        @onReplaceWithChange="updateReplaceWith"
        @onToReplaceChange="updateToReplace"
        @onRegexValidate="updateRegexValidity"
        @onOptionSelect="updateReplaceWith"
        :availableOptions="rule.options"
        :availableSourceVariables="availableSourceVariables"
        :columnName="rule.columnName"
        :operationType="rule.operationType"
        :replaceWith="rule.replaceWith"
        :toReplace="rule.toReplace">
      </format>
    </div>
    <template #modal-footer>
      <button class="btn btn-small btn-gray-dark" @click="saveRule" :disabled="!isValid">
        <save-icon></save-icon>
        <span>{{$t('global.save')}}</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import { EditIcon, SaveIcon, XIcon } from 'vue-feather-icons'
import SourceVariable from './SourceVariable'
import Conditions from './Conditions'
import Format from './Format'

export default {
  name: 'RuleEditModal',

  data () {
    return {
      availableSourceVariables: this.sourceVariables,
      availableTemplateFields: this.templateFields,
      rule: {
        areConditionsValid: true,
        columnName: '',
        conditions: [],
        isRegexValid: true,
        mappingRule: {},
        operationType: '',
        operationTypeLabel: '',
        options: [],
        replaceWith: '',
        sourceVariable: '',
        toReplace: ''
      }
    }
  },

  props: {
    currentRule: { required: true, type: Object },
    mappingRules: { required: true, type: Array },
    sourceVariables: { required: true, type: Array },
    templateFields: { required: true, type: Array }
  },

  created () {
    //
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.rule.columnName = this.currentRule.columnName
      this.rule.conditions = this.currentRule.conditions
      this.rule.areConditionsValid = this.currentRule.areConditionsValid
      this.rule.mappingRule = this.currentRule.mappingRule
      this.rule.operationType = this.currentRule.operationType
      this.rule.operationTypeLabel = this.currentRule.operationTypeLabel
      this.rule.options = this.currentRule.options
      this.rule.replaceWith = this.currentRule.replaceWith
      this.rule.sourceVariable = this.currentRule.sourceVariable
      this.rule.toReplace = this.currentRule.toReplace
    })

    this.$root.$on('bv::modal::hide', () => {
      this.rule = { areConditionsValid: true, columnName: '', conditions: [], mappingRule: {}, operationType: '', operationTypeLabel: '', options: [], replaceWith: '', sourceVariable: '', toReplace: '' }
    })
  },

  methods: {
    saveRule () {
      this.$emit('onRuleSave', this.rule)
      this.$root.$emit('bv::hide::modal', 'ruleEditModal')
    },

    hideModal () {
      this.$root.$emit('bv::hide::modal', 'ruleEditModal')
    },

    updateMappingRule (mappingRule) {
      this.rule.columnName = mappingRule.to
      this.rule.conditions = []
      this.rule.areConditionsValid = true
      this.rule.mappingRule = mappingRule
      this.rule.operationType = ''
      this.rule.operationTypeLabel = ''
      this.rule.options = this.availableTemplateFields.filter(field => field.name === this.rule.columnName)[0].options
      if (this.rule.options.length > 0) {
        this.rule.operationType = 'choose'
        this.rule.operationTypeLabel = this.$t('operations.choose')
      }
      this.rule.replaceWith = ''
      this.rule.sourceVariable = mappingRule.fromLabel
      this.rule.toReplace = ''
    },

    updateConditions (conditions) {
      this.rule.conditions = conditions
    },

    updateRuleType (operationType) {
      this.rule.operationType = operationType.value
      this.rule.operationTypeLabel = operationType.label
      this.rule.replaceWith = ''
      this.rule.toReplace = ''
      if (operationType.value === 'choose') this.rule.options = this.availableTemplateFields.filter(field => field.name === this.rule.columnName)[0].options
    },

    updateReplaceWith (replaceWith) {
      this.rule.replaceWith = replaceWith
    },

    updateToReplace (toReplace) {
      this.rule.toReplace = toReplace
    },

    updateConditionsValidity (conditionsValidity) {
      this.rule.areConditionsValid = conditionsValidity
    },

    updateRegexValidity (regexValidity) {
      this.rule.isRegexValid = regexValidity
    }
  },

  computed: {
    isValid () {
      if (!this.rule.areConditionsValid) return false
      else {
        if (this.rule.columnName !== '') {
          if (this.rule.operationType === 'replace') {
            return this.rule.toReplace !== ''
          } else if ((this.rule.operationType === 'format') || (this.rule.operationType === 'choose')) {
            return this.rule.replaceWith !== ''
          } else if ((this.rule.operationType === 'regex') || (this.rule.operationType === 'regex match')) {
            return (this.rule.toReplace !== '') && (this.rule.isRegexValid)
          } else return ((this.rule.operationType === 'value') || (this.rule.operationType === 'xml'))
        } else return false
      }
    }
  },

  components: { Conditions, EditIcon, Format, SaveIcon, SourceVariable, XIcon }
}
</script>
